/**
 * Redige chaves de API de provedores de IA (OpenAI `sk-…`, Claude `sk-ant-…`, Google `AIza…`)
 * em texto livre antes de ir a PostHog/Sentry (BYOKU-10).
 */
export const REDACTED_PROVIDER_KEY = '[redacted]'

const PROVIDER_API_KEY = /\b(?:sk-[A-Za-z0-9_-]{16,}|AIza[0-9A-Za-z_-]{20,})/g

export function redactProviderKeys(text: string): string {
  return text.replace(PROVIDER_API_KEY, REDACTED_PROVIDER_KEY)
}
